import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/stable";
// import 'react-app-polyfill/ie11'; // For IE 11 support
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import store from "./redux/store";
import version from "./version.json";
import Theme from "./Theme";
import "./App.scss";
import { AlertasProvider } from "./views/Pantalla/context/AlertaContext";
import createFastContext from "./views/Pantalla/context/refContext";
import { initialState } from "./views/Pantalla/context/PantallaReducer";

export const { RefProvider, useRefStore } = createFastContext(initialState);
export const { RefProvider: RefDataProvider, useRefStore: useRefDataStore } =
  createFastContext({});

window.__CFSF_VERSION__ = version;
console.info(
  `CFSF ${version.sha} (${version.rama}) — compilado ${version.compilado}`
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
   
      <Theme>
        <AlertasProvider>
          <RefProvider>
            <RefDataProvider>
              <App />
            </RefDataProvider>
          </RefProvider>
        </AlertasProvider>
      </Theme>
    
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
